import React, { Component, Suspense } from 'react';
import { Card, Form, Col, Row, Alert, Container } from 'react-bootstrap';
import { CodingWorksheetService } from '../../services';
import logoBig from '../../assets/img/brand/logo.png';

import * as WorksheetControls from '../../controls/worksheetcontrols';
import CustomerCodingEventService from '../../services/CustomerCodingEventService';
import { useImmer } from 'use-immer';
import { useEffect } from 'react';
import { useParams } from 'react-router';


const CustomerWorksheetPrint = (props) => {
    const [state, setState] = useImmer({ worksheet: { masterSections: [] }, worksheetAnswers: {} });

    //useEffect(() => {
    //    setState({
    //        worksheet: props.worksheet,
    //        worksheetAnswers: props.answers
    //    });
    //}, [])

    const { id } = useParams();

    useEffect(() => {
        getWorksheet();
    }, [])

    useEffect(() => {
        var info = state.worksheetAnswers.information;
        if (info != undefined) {
            var assessmentDate = (info.ASSESSMENT_DATE ?? "NULL");
            var oasisType = (info.OASIS_TYPE ?? "NULL").replaceAll(' ', '-')
            var patientIdMrn = (info.PATIENT_ID_MRN ?? "NULL").replaceAll(' ', '-')
            var clinician = (info.AUTHORING_CLINICIAN ?? "NULL").replaceAll(' ', '-')
            document.title = `${assessmentDate}_${oasisType}_${patientIdMrn}_${clinician}`
        }
    }, [state])

    const getWorksheet = async () => {
        var eventService = new CustomerCodingEventService();
        var callResult = await eventService.getWorksheet(id);

        if (callResult.result) {
            let vm = callResult.model.codingEventWorksheet;
            setState({
                worksheet: vm.worksheet,
                worksheetAnswers: vm.worksheetAnswers
            });
        }
    }

    const buildWorksheet = () => {
        var worksheet = state.worksheet;
        var sections = worksheet.masterSections.map((section) => buildSection(section));

        return sections;
    }

    const buildSection = (section) => {
        var partialState = state.worksheetAnswers;
        //if (partialState[section.fieldName] === undefined || partialState[section.fieldName] === null) {
        //    partialState[section.fieldName] = {};

        //    this.setState({ worksheetAnswers: partialState });
        //}

        var unchanged = true;

        if (section.reviewable && (partialState[section.controlGroup] !== undefined || partialState[section.controlGroup] !== null)) {
            // check to see if any values are changed - if not - don't display it

            section.masterQuestions.forEach(question => {
                let sectionVal = partialState[section.controlGroup];
                if (sectionVal !== undefined && sectionVal != null) {
                    if (sectionVal[question.controlGroup] != undefined &&
                        (sectionVal[question.controlGroup]['Initial'] != undefined
                            || sectionVal[question.controlGroup]['Revised'] != undefined
                            || sectionVal.Rationale !== "")) {
                        // so one of either the initial or revised or rationale has been set... so something has changed.
                        unchanged = false;  // this will always be false once set to false.
                    }
                }
            });
            if (!unchanged) {


                return (
                    <div style={{ pageBreakInside: "avoid" }}>
                        <div className="title-header">{section.controlGroup}: {section.name}</div>
                        <Form.Row>
                            <Col>
                                <Form.Label><b>Initial</b></Form.Label> <br />
                                {section.masterQuestions.map(
                                    (question) => buildQuestion(question, section.controlGroup, 'Initial'))}
                            </Col>
                            <Col>
                                <Form.Label><b>Revised</b></Form.Label><br />
                                {section.masterQuestions.map(
                                    (question) => buildQuestion(question, section.controlGroup, 'Revised'))}
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} lg="12">
                                <Form.Label><b>Rationale</b></Form.Label><br />
                                {state.worksheetAnswers[section.controlGroup]['Rationale']}
                            </Form.Group>
                        </Form.Row>
                    </div>
                );
            } else {
                return null;
            }
        } else {
            section.masterQuestions.forEach(question => {
                let sectionVal = partialState[section.controlGroup];
                if (sectionVal !== undefined && sectionVal !== null) {
                    if (sectionVal[question.controlGroup] != undefined) {
                        unchanged = false;
                    }
                }
            });
            if (!unchanged) {
                return (
                    <div style={{ pageBreakInside: "avoid" }}>
                        <div className="title-header">{section.name}</div>
                        <Form.Row>
                            {section.masterQuestions.map((question) => buildQuestion(question, section.controlGroup, null))}
                        </Form.Row>
                    </div>
                );
            }
        }

    }

    const buildQuestion = (question, parentControlGroup, controlFieldName) => {
        try {
            let Control = WorksheetControls[question.controlType];
            let parentName = parentControlGroup + ':' + question.controlGroup;
            let unchanged = true;
            if (controlFieldName !== null) {
                var partialState = state.worksheetAnswers;
                if (partialState[parentControlGroup][question.controlGroup] === undefined ||
                    partialState[parentControlGroup][question.controlGroup] === null) {
                    partialState[parentControlGroup][question.controlGroup] = {}
                    setState(draft => { draft.worksheetAnswers = partialState });
                    unchanged = false;
                }
                // check if they are the same, or if initial and revised are different.
                if (partialState[parentControlGroup][question.controlGroup]['Initial'] !==
                    partialState[parentControlGroup][question.controlGroup]['Revised']) {
                    unchanged = false;
                }
                let controlName = parentName + ':' + controlFieldName;
                if (!unchanged) {
                    return (
                        <Control 
                            parentControlGroup={parentControlGroup} print
                            name={controlName}
                            value={state.worksheetAnswers[parentControlGroup][question.controlGroup][controlFieldName]} {...question} />
                    );
                }
            } else {
                if (state.worksheetAnswers[parentControlGroup][question.controlGroup] !== undefined
                    && state.worksheetAnswers[parentControlGroup][question.controlGroup] !== null
                    && state.worksheetAnswers[parentControlGroup][question.controlGroup] !== "") {

                    const colLg = question.controlType === 'WorksheetTextarea' ? 12 : 4;
                    const colMd = question.controlType === 'WorksheetTextarea' ? 12 : 6;
                    return (
                        state.worksheetAnswers[parentControlGroup] != undefined
                            ? <Control 
                                colLg={colLg}
                                colMd={colMd}
                                name={parentName}
                                parentControlGroup={parentControlGroup} print
                                value={state.worksheetAnswers[parentControlGroup][question.controlGroup]}
                                {...question} />
                            : null
                    );
                }
            }
        } catch (err) {
            return <Alert variant="danger">Error: {err.message} on loading control: {question.controlType} of question {question.label}</Alert>
        }
    }

    return (
        <div  id="printView">
            <Container>
            <Row>
                <Col>
                    <img
                        src={logoBig}
                        className="d-inline-block"
                        alt="Generic Logo"
                    />
                </Col>
                <Col className="d-flex justify-content-center align-items-center">
                    <b>{state.worksheet.name}</b>
                </Col>
                <Col className="d-flex justify-content-end align-items-center text-right">

                    Ph: 800.841.6095<br />
                            Fax: 1-417-227-1302<br />
                            www.healthcarefirst.com
                            </Col>
                </Row>
            <div className="mt-3 mb-3">
                <b>Please review the following items for recommendations and changes for compliance with CMS.</b>
            </div>
                {buildWorksheet()}
            </Container>
        </div>
    );
}
export default CustomerWorksheetPrint;